document.addEventListener("DOMContentLoaded", function () {
  const invalidDomains = [
    "example.com",
    "example.net",
    "example.org",
    "test.com",
    "fake.com",
    "demo.com"
  ];

  const invalidPrefixes = ["test@", "demo@", "fake@", "prueba@"];

  function isInvalidEmail(email) {
    const lowerEmail = email.toLowerCase();
    return (
      invalidDomains.some(domain => lowerEmail.endsWith("@" + domain)) ||
      invalidPrefixes.some(prefix => lowerEmail.startsWith(prefix))
    );
  }

  function attachValidation(input) {
    if (!input) return;

    input.addEventListener("input", function () {
      const email = input.value.trim();

      if (isInvalidEmail(email)) {
        input.setCustomValidity("Este correo no está permitido. Por favor usa un correo válido.");
        input.reportValidity();
        input.classList.add("invalid-email");
      } else {
        input.setCustomValidity("");
        input.classList.remove("invalid-email");
      }
    });
  }

  // Buscar los campos comunes de email en Shopify (registro, checkout, carrito)
  const selectors = [
    'input[type="email"]',
    'input[name="email"]',
    'input[id*="email"]',
    'input[data-testid="field-email"]'
  ];

  const emailInputs = document.querySelectorAll(selectors.join(","));
  emailInputs.forEach(input => attachValidation(input));

  // Prevenir envío si el email es inválido
  document.querySelectorAll("form").forEach(form => {
    form.addEventListener("submit", function (e) {
      const emailField = form.querySelector(selectors.join(","));
      if (emailField && isInvalidEmail(emailField.value)) {
        e.preventDefault();
        emailField.reportValidity();
      }
    });
  });
});
